import Step from './step';
var Steps = /** @class */ (function () {
    function Steps(data) {
        this.steps = [];
        this.totalQuestions = 0;
        this.currentIndex = 0;
        this.nextIndex = 1;
        this.parseData(data);
    }
    Steps.prototype.setCurrentIndex = function (r) {
        this.currentIndex = r;
    };
    Object.defineProperty(Steps.prototype, "currentIndexValue", {
        get: function () {
            return this.currentIndex;
        },
        enumerable: false,
        configurable: true
    });
    Steps.prototype.setNextIndex = function (r) {
        this.nextIndex = r;
    };
    Object.defineProperty(Steps.prototype, "nextIndexValue", {
        get: function () {
            return this.nextIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Steps.prototype, "stepsArray", {
        get: function () {
            return this.steps;
        },
        enumerable: false,
        configurable: true
    });
    Steps.prototype.next = function () {
        var val = {
            done: this.currentIndex >= this.steps.length - 1,
            value: this.steps[this.nextIndex],
        };
        if (val.done) {
            val.value = this.steps[0];
        }
        return val;
    };
    Steps.prototype.prev = function () {
        var val = {
            done: this.currentIndex >= this.steps.length,
            value: this.steps[this.currentIndex - 1],
        };
        return val;
    };
    Steps.prototype.parseData = function (data) {
        this.steps = data.map(function (question) { return new Step([question]); });
        var _loop_1 = function (i) {
            var head = this_1.steps[i].questionList[0].id;
            if (this_1.steps[i].questionList[0].hasSubs) {
                var group = this_1.steps.filter(function (temp) {
                    return temp.questionList[0].dependencies.find(function (o) { return Number(o.id) === head; });
                });
                for (var _i = 0, _a = group.slice(1); _i < _a.length; _i++) {
                    var el = _a[_i];
                    this_1.steps[i + 1].questionList.push(el.questionList[0]);
                }
                this_1.steps.splice(i + 2, group.length - 1);
            }
        };
        var this_1 = this;
        for (var i = 0; i < this.steps.length; i++) {
            _loop_1(i);
        }
        this.totalQuestions = this.steps.length;
    };
    return Steps;
}());
export default Steps;
